// Actions

import axios from '@/axios.js'

export default {
  GetList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/recipient/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  DeleteRecipient({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/recipient/${id}`,
        id,
        method: 'DELETE'
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  AddRecipient({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/recipient',
        data: payload,
        method: 'POST'
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
